import React, { Component } from 'react';
import AddServiceCall from './addServiceCall'
class ServiceCallInfo extends Component {
    render(){
        return(
            <AddServiceCall />
        )
    }
}
export default ServiceCallInfo